var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookItemFigureOverlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 141 189",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.999848 0.0174524 -0.0174524 0.999848 1.65415 -1.20862)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient",
    x1: 6.42237,
    x2: 14.4212,
    y1: 83.7913,
    y2: 83.6517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#000000",
    stopOpacity: 0.22963
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 1.352e-10 -1.352e-10 1 1.61303 -1.13917)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient_2",
    x1: 4.5,
    x2: 4.5,
    y1: 2.32117,
    y2: 186.321
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f9f9",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.999848 0.0174524 -0.0174524 0.999848 1.65415 -1.20862)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient_3",
    x1: 2.02751,
    x2: 5.2109,
    y1: 3.95182,
    y2: 186.328
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f9f9",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.999848 0.0174524 -0.0174524 0.999848 1.65415 -1.20862)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient_4",
    x1: 1.37716,
    x2: 6.10105,
    y1: 81.2907,
    y2: 81.2082
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 1.352e-10 -1.352e-10 1 1.58182 1.13023)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient_5",
    x1: 134.62,
    x2: 134.62,
    y1: 2.97473,
    y2: 180.054
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f9f9",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 1.352e-10 -1.352e-10 1 -1.53897 -0.988658)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient_6",
    x1: 134.59,
    x2: -14.4368,
    y1: 183.951,
    y2: 183.951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f8f8",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57933 187.193L133.698 187.055C134.021 187.054 134.323 186.898 134.51 186.636L135.598 185.11L2.12906 185.111L7.20996 187.123C7.32752 187.17 7.45285 187.194 7.57933 187.193Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.2,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12937 185.111L8.56908 186.624C8.62596 186.643 8.68623 186.651 8.74612 186.646C9.15886 186.613 9.30396 186.081 8.96494 185.844L7.91932 185.111L4.12937 185.111Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.21,
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.661 1.18203L8.06263 1.18203L8.06262 183.182C8.06262 184.213 8.84297 185.062 9.84533 185.171C9.6793 184.879 9.58448 184.541 9.58445 184.182L9.58446 3.18201C9.58447 2.62973 10.0322 2.18201 10.5845 2.18201L135.612 2.18201C136.504 2.18201 137.327 2.47354 137.992 2.96645C137.275 1.89074 136.051 1.18203 134.661 1.18203Z",
    fill: "#f8f9f9",
    fillRule: "evenodd",
    opacity: 0.2,
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61208 183.182C1.61207 184.287 2.50752 185.182 3.61209 185.182L134.612 185.182C136.821 185.182 138.612 183.391 138.612 181.182L138.612 5.18199C138.612 3.56143 137.648 2.16596 136.263 1.53741C136.489 2.03905 136.615 2.5958 136.615 3.18199L136.616 181.182C136.615 182.287 135.72 183.182 134.615 183.182L1.61544 183.182C1.61432 183.182 1.6132 183.182 1.61208 183.182Z",
    fill: "#000000",
    fillRule: "evenodd",
    opacity: 0.05,
    stroke: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61318 5.17194C6.61319 3.72833 7.64136 2.48942 9.06024 2.22334L14.6132 1.182L14.6132 185.182L6.61318 185.182L6.61318 5.17194Z",
    fill: "url(#LinearGradient)",
    fillRule: "nonzero",
    opacity: 0.15,
    stroke: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61303 1.182L6.61303 1.182L6.61303 1.182L6.61303 185.182L6.61303 185.182L5.61303 185.182L5.61303 185.182L5.61303 1.182L5.61303 1.182Z",
    fill: "url(#LinearGradient_2)",
    fillRule: "nonzero",
    opacity: 0.2,
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.61239 2.77798L5.61239 2.0796L5.61239 184.609L1.61238 183.847L1.61239 2.77798Z",
    fill: "url(#LinearGradient_3)",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.61239 2.77798L5.61239 2.0796L5.61239 184.609L1.61238 183.847L1.61239 2.77798Z",
    fill: "url(#LinearGradient_4)",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.621 4.10496L136.783 4.10496L136.783 4.10496L136.783 181.185L136.783 181.185L135.621 181.185L135.621 181.185L135.621 4.10496L135.621 4.10496Z",
    fill: "url(#LinearGradient_5)",
    fillRule: "nonzero",
    opacity: 0.1,
    stroke: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2171 181.849L134.436 181.849C134.744 181.849 134.993 182.099 134.993 182.406L134.993 182.406C134.993 182.714 134.744 182.963 134.436 182.963L13.2171 182.963C12.9095 182.963 12.6602 182.714 12.6602 182.406L12.6602 182.406C12.6602 182.099 12.9095 181.849 13.2171 181.849Z",
    fill: "url(#LinearGradient_6)",
    fillRule: "nonzero",
    opacity: 0.1,
    stroke: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05123 185.146L135.597 185.146L135.259 185.826L9.18801 185.825L8.05123 185.146Z",
    fill: "#9b9693",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookItemFigureOverlay);
export default __webpack_public_path__ + "static/media/book-item-figure-overlay.b0fa82eaf38d60d6d804d0f0ff2abf3a.svg";
export { ForwardRef as ReactComponent };